import React from "react";
import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import {
  AuthContextProvider,
  ConfigContextProvider,
  EventsContextProvider,
  InfoContextProvider,
  MembersContextProvider,
} from "./context";
import { Theme } from "./config";
import { Navigator } from "./routing/Navigator";

const App = () => {
  const muiTheme = createTheme({
    palette: {
      primary: {
        main: Theme.primary,

      },
      secondary: {
        main: Theme.secondary,
      },
    },
    typography: {
      h1: { fontSize: "3rem", fontWeight: 600 },
      h2: { fontSize: "2rem", fontWeight: 600 },
      h3: { fontSize: "1.8rem", fontWeight: 500 },
      h4: { fontSize: "1.5rem", fontWeight: 500 },
      caption: {
        fontWeight: 700,
        fontSize: "medium",
      },
    },
  });
  return (
    <ThemeProvider theme={muiTheme}>
      <AuthContextProvider>
        <MembersContextProvider>
          <ConfigContextProvider>
            <InfoContextProvider>
              <EventsContextProvider>
                <Navigator />
              </EventsContextProvider>
            </InfoContextProvider>
          </ConfigContextProvider>
        </MembersContextProvider>
      </AuthContextProvider>
    </ThemeProvider>
  );
};

export default React.memo(App);
